import React, { useState } from 'react';
import axios from '../api/api';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {

  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('/security/send-reset-code',
        { email }
      );
      toast.info('Reset code sent! Check your phone.');
      navigate('/password-reset');
    } catch (error) {
      console.log(error);
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 401) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Failed to send code.')
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='mx-auto'>
      <div className='flex items-center justify-center h-[100vh]'>
        <div className='bg-white p-4 rounded-lg w-full xl:w-1/3 2xl:w-1/4'>
          <div className='text-center'>
            <h2><b>Get Otp Code.</b></h2>
            <p>Enter your details below</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className='my-3'>
              <label htmlFor='email'><span>Email Address</span>
                <input
                  type='email'
                  required
                  placeholder='user@gmail.com'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
            </div>
            <div>
              <button disabled={loading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md w-full hover:bg-[#165277]'>{loading ? 'Please Wait...' : 'Get Code'}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
